import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogErrorRedirectComponent } from './dialog-error-redirect.component';
import { MatButtonModule } from '@angular/material/button';
import { SolButtonModule } from '../../../../ui/shared/components/sol-button/sol-button.module';
import { SolCardModule } from '../../../../ui/shared/components/sol-card/sol-card.module';
import { SolButtonActionsComponent } from '../../../../ui/shared/components/sol-button-actions/sol-button-actions.component';

@NgModule({
    declarations: [DialogErrorRedirectComponent],
    exports: [DialogErrorRedirectComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        SolButtonModule,
        SolCardModule,
        SolButtonActionsComponent,
    ],
})
export class DialogErrorRedirectModule {}
